import { Svg } from '@repo/ui';

import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';

interface Props {
  onPrimaryButtonClick: () => void;
}

const HometaxMaintenanceError = ({ onPrimaryButtonClick }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_exclamation-mark_md.svg" width={80} height={80} />,
    title: '현재 홈택스 점검으로\n환급액 조회가 어려워요',
    description: '이용에 불편을 드려 죄송합니다.\n점검 후 다시 시도해주세요.',
    primaryButtonText: '홈으로',
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonVariant: 'tonal-secondary'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default HometaxMaintenanceError;
